import { MediaPlayerRemoteInteractionType } from 'features/content-library/types';

export const SHARED_FOLDER_ID = 'shared';

export const PLAYER_FIELD_BY_INTERACTION_TYPE = {
  playback: 'state',
  volume: 'volume',
  mute: 'muted',
  seek: 'currentTime',
} as const satisfies Record<MediaPlayerRemoteInteractionType, string>;

export const SELECT_ALL_ITEMS_ID = 'select-all-item';
export const SHARE_SELECT_ALL_AVATAR_COLOR = '#03A678';

export const CONTENT_LIBRARY_SORT_BY_STORAGE_KEY = 'content_library_sort_by';
